import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../service/authentication.service';
import { PresenzeService } from '../service/presenze.service';
import { BusyProvider } from '../service/busy.service';
import { AuthAccessProvider } from '../core/core.auth';
import { UserContext, BaseComponent, CheckedInResponse } from '../core/core.component';
import { MessageProvider } from '../service/message.service';
import 'rxjs/add/operator/timeout';
import { TimeoutError } from 'rxjs/Rx';
import { environment } from '../../environments/environment';
import { AppConstants } from '../core/app.constants';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  providers: [PresenzeService]
})
export class LoginComponent extends BaseComponent implements OnInit {

  userId: string = "";
  password: string = "";
  userContext: UserContext = null;
  // password scaduta o da cambiare al primo accesso: al posto del login viene mostrato il cambio password
  passwordExpired: boolean = false;
  expiredOldPassword: string = "";

    @Input() 
    set userCtx(userctx: UserContext){
            this.userContext = userctx;
    }
    get userCtx() {
        return this.userContext;
    }

  constructor(protected authAccess: AuthAccessProvider,
              protected router: Router,    
              protected messageProvider: MessageProvider, 
              private authService: AuthenticationService,
              private presenzeService: PresenzeService,
              private busyProvider: BusyProvider) 
  { 
      super(authAccess, router, messageProvider);
      if(this.authAccess.getUserContext() != null) {
          this.router.navigate(['/']);
      }
  }

  ngOnInit() {}

  login()
  {
      let typedPassword = this.password;
      this.busyProvider.showBusyIndicator();
      this.authService.login(this.userId, this.password).timeout(environment.SERVICE_TIMEOUT).
      subscribe(response => {
         
         this.password = null;
         this.userCtx = response;
         if(this.userCtx != null && typeof(this.userCtx) != 'undefined'  && this.userContext.srmToken != null)
         {
             this.authAccess.setUserContext(this.userContext);
             var checkedInRes: CheckedInResponse;
             this.presenzeService.isCheckedIn(this.userContext.srmToken).subscribe(
                  result => {
                      this.busyProvider.hideBusyIndicator();
                      this.password = "";
                      checkedInRes = result;
                      if(checkedInRes.isCheckedIn) {
                          this.router.navigate(['/']);
                      } else {
                          this.router.navigate(['/cartellino']);
                      }
                  },
                  error => {
                      this.busyProvider.hideBusyIndicator();
                      this.password = "";
                      this.handleError(error);
                  },
             );
         } else {
             this.busyProvider.hideBusyIndicator();
         }
      }, 
      error => {
          this.messageProvider.clearAll();
          this.password = "";
          if(error instanceof TimeoutError) {
              this.error.message = AppConstants.TIMEOUT_EXPIRED_MSG;
          } else {
              let body = error.json();
              if(body && body.passwordExpired) {
                  this.expiredOldPassword = typedPassword;
                  this.passwordExpired = true;
                  this.busyProvider.hideBusyIndicator();
                  this.messageProvider.notifyWarning(body.message);
                  return;
              }
              this.error = JSON.parse(JSON.stringify(body));
              if(!this.error.status || !this.error.message) {
                 this.error.message = error;
                 alert(error);
              }
          }
          this.busyProvider.hideBusyIndicator();
          this.messageProvider.notifyError(this.error.message);
      });
  }

  // cambio della password scaduta riuscito: accesso con la nuova password
  onPasswordChanged(newPassword: string)
  {
      this.passwordExpired = false;
      this.expiredOldPassword = "";
      this.password = newPassword;
      this.login();
  }

  onPasswordChangeCancelled()
  {
      this.passwordExpired = false;
      this.expiredOldPassword = "";
  }
}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts